import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, FieldArray, useFormikContext } from 'formik';

import { ReactComponent as AddButton } from '../../../../../assets/images/AddButton.svg';
import { ReactComponent as CrossIcon } from '../../../../../assets/images/CrossIcon.svg';
import CustomTextField from '../../../../../components/shared/CustomTextField/CustomTextField';

import styles from '../AddContactModal.module.scss';

const ContactFormCustomFieldWeb = () => {
  const { t } = useTranslation('common');
  const { values } = useFormikContext();

  const handleRemoveField = useCallback(
    (arrayHelpers, index) => {
      if (values.custom_fields.length === 1) {
        arrayHelpers.replace(index, { custom_field: '', label: '' });
      } else {
        arrayHelpers.remove(index);
      }
    },
    [values]
  );

  return (
    <div>
      <FieldArray
        name="custom_fields"
        render={(arrayHelpers) => (
          <div className={styles.container}>
            {values.custom_fields?.map((value, index) => {
              const { _destroy } = value;
              if (!_destroy) {
                return (
                  <div className={styles.multiInputWrapper}>
                    <div className={styles.multiInputContainer}>
                      <div className={styles.multiInputField}>
                        <Field
                          name={`custom_fields[${index}].custom_field`}
                          as={CustomTextField}
                          value={value.custom_field}
                          type="text"
                          label={t('contactModal.customField')}
                        />
                      </div>
                      {value.custom_field.length > 0 && (
                        <div className={styles.multiInputField}>
                          <Field
                            name={`custom_fields[${index}].label`}
                            as={CustomTextField}
                            value={value.label}
                            label={t('contactModal.label')}
                          />
                        </div>
                      )}
                    </div>
                    <div
                      className={
                        value.custom_field?.length > 0 ? styles.showIconButtonContainer : styles.iconButtonContainer
                      }
                    >
                      <button
                        type="button"
                        onClick={() => handleRemoveField(arrayHelpers, index)}
                        className={styles.iconButton}
                      >
                        <CrossIcon />
                      </button>
                      {value.custom_field.length > 0 && index === values.custom_fields.length - 1 && (
                        <button
                          className={styles.iconButton}
                          type="button"
                          onClick={() => arrayHelpers.insert(index + 1, { custom_field: '', label: '' })}
                        >
                          <AddButton />
                        </button>
                      )}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        )}
      />
    </div>
  );
};

export default ContactFormCustomFieldWeb;
